<template>
    <div class="mobile-not-supported text-center">
        <a class="logo" href="/homepage"><img src="/img/pillar-logo2x.png" alt="logo"></a>
        <h5 class="text-primary mb-24">Continue editing your website on a desktop computer</h5>
        <p class="text-secondary">We’re working hard to support website creation on mobile devices. In the meantime, please login on your desktop computer to continue building your website</p>
        <a href="/homepage" class="button button-l button-secondary mb-24 block-margin">Homepage</a>
    </div>
</template>

<script>
    export default {
        mounted() {
        }
    }
</script>
